<ngx-spinner bdColor="rgba(51,51,51,0.8)" size="medium" color="#fff" loadingText="Loading..."
  type="ball-scale-multiple"></ngx-spinner>
<app-header></app-header>
<div #rackPage class="container-fluid">
  <div class="row">
    <div class="col-lg-8 col-md-4">
      <div class="rackUploadHeading">
          {{'Rack Upload' | translate}}
      </div>
    </div>
    <div class="col-lg-2 col-md-4 downloadTemplate">
      <div class="addRackInfo">
        <button class="btn btn-dark" (click)="openAddRack()">
            {{'Add One Rack Code' | translate}}
          </button>
    </div>
    </div>
    <div class="col-lg-2 col-md-4 downloadTemplate">
      <button class="btn btn-dark" (click)="downloadRackCodesTemplate()">
        <i class="fa fa-download" aria-hidden="true"></i>&nbsp;&nbsp;
        {{'Rack Template file' | translate}}
      </button>
    </div>
    <!-- <div class="col-lg-2 col-md-4 formFontSection">
      <div class="btn-group" role="group" aria-label="Basic example">
        <button type="button" class="btn btn-danger btn-sm" (click)="changeFont('-')">
          <mat-icon>remove</mat-icon>
        </button>
        <button type="button" class="btn btn-light btn-sm">{{'Font Size' | translate}}</button>
        <button type="button" class="btn btn-success btn-sm" (click)="changeFont('+')">
          <mat-icon>add</mat-icon>
        </button>
      </div>
    </div> -->
  </div>

  <div class="container-fluid">
    <div class="row">
      <div class="col-lg-8 col-md-8">
        <div class="row buildingNumberRow">
          <div class="col">
            <label class="buildingLabel">{{'Building Number' | translate}}</label>
          </div>
          <div class="col">
            <mat-select class="selectBuildingNumber" placeholder="Building Number" (change)="onBuildingChange($event)" [formControl]="buildings" multiple>
              <mat-select-trigger>
                <mat-chip-listbox>
                  <mat-chip class="buildingChips" *ngFor="let build of buildings.value" [removable]="true"
                    (remove)="onBuildingRemoved(build)">
                    {{ build }}
                    <mat-icon matChipRemove>cancel</mat-icon>
                  </mat-chip>
                </mat-chip-listbox>
              </mat-select-trigger>
              <mat-option *ngFor="let building of buildingNumberList" [value]="building">{{building}}</mat-option>
            </mat-select>
          </div>
          <div class="col">
            <button class="btn btn-outline-success searchBuildingButton" [disabled]="buildingArrLength === 0" type="button"
              (click)="searchByBuildingNumber()">{{'Search' | translate}}</button>
            <button class="btn btn-outline-success searchBuildingButton btnSpace" type="button"
              (click)="resetSearch()">{{'Reset Search' | translate}}</button>
          </div>
        </div>

        <div class="row rackCodeRow">
          <div class="col">
            <label class="rackLabel">{{'Rack Code' | translate}}</label>
          </div>

          <div class="col">
            <input class="rackInput" placeholder="Rack Code" #rackCodeInput matInput (input)="getRackCodeChar($event)"
              [matAutocomplete]="auto">
            <mat-autocomplete #auto="matAutocomplete">
              <span *ngIf="rackCodeFilteredOptions">
                  <mat-option *ngFor="let option of rackCodeFilteredOptions" [value]="option">
                      {{option}}
                    </mat-option>
              </span>
              <span *ngIf="noRackCodeRecords.length !== 0">
                  <mat-option>
                      {{'No Rack Codes found' | translate}}
                      <!-- {{noRackCodeRecords}} -->
                    </mat-option>
              </span>
            
            </mat-autocomplete>
            <!-- <mat-hint >{{noRackCodeRecords}}</mat-hint> -->
          </div>

          <div class="col">
            <button class="btn btn-outline-success searchBuildingButton"
              [disabled]="rackCodeLength < 3 || rackCodeLength > 8" type="button"
              (click)="searchByRackCode()">{{'Search' | translate}}</button>
          </div>
        </div>

        <div class="row">
          <div class="col-6 exampleText">
            {{'Can be filtered by inputting *Value (ex.*16S50)' | translate}}
          </div>
        </div>

      </div>
      <div class="col-lg-4 col-md-4 rackBuildingIconColumn">
        <div class="row">
          <div class="col">
            <label class="rackMap" for="">
              <img src="../../../assets/Frame 4.svg" alt="">
            </label>
            <div style="text-align: center">
                {{'Rack Map' | translate}}
            </div>
          </div>
          <div class="col">
            <label class="uploadRack" for="rackInputFile">
              <img src="../../../assets/Frame 2.svg" alt="">
            </label>
            <div style="text-align: center">
                {{'Upload' | translate}}
            </div>
            <input type="file" #rackInput id="rackInputFile" (change)="onFileChange($event)" style="display: none" />
          </div>
          <div class="col">
            <label class="downloadRack" for="" (click)="downloadRackCSV()">
              <img src="../../../assets/downloadIcon.svg" alt="">
            </label>
            <div style="text-align: center">
                {{'Download' | translate}}
            </div>
          </div>
          <!-- <div class="col">
            <label (click)="goTo()" class="returnToDashboard" for="">
              <img src="../../../assets/Frame 1.svg" alt="">
            </label>
            <div style="text-align: center">
                {{'Return to Dashboard' | translate}}
            </div>
          </div> -->
        </div>

      </div>
    </div>
  </div>
  <!-- <div class="addRackInfo">
      <button class="btn btn-dark" (click)="openAddRack()">
          Add Rack Info
        </button>
  </div> -->
  <div class="rackTable">
  
      <div class="row">
          <div class="col">
            <div class="groupDelete">
                <button [disabled]="!selection.selected.length" class="btn btn-dark" (click)="deleteBulkData()">{{'Group Delete' | translate}}</button>
            </div>
          </div>
          <div class="col">
              <div class="units">
                  {{'unit:m(meter)' | translate }}
             </div>
          </div>
        </div>
    <div class="example-container mat-elevation-z8" >
      <mat-table #table [dataSource]="dataSource" matSort (matSortChange)="sortData($event)">

          <ng-container matColumnDef="select">
              <mat-header-cell *matHeaderCellDef>
                <mat-checkbox (change)="$event ? masterToggle() : null"
                              [checked]="selection.hasValue() && isAllSelected()"
                              [indeterminate]="selection.hasValue() && !isAllSelected()">
                </mat-checkbox>
              </mat-header-cell>
              <mat-cell *matCellDef="let row">
                <mat-checkbox (click)="$event.stopPropagation()"
                              (change)="$event ? selection.toggle(row) : null"
                              [checked]="selection.isSelected(row)">
                </mat-checkbox>
              </mat-cell>
            </ng-container>

        <ng-container matColumnDef="rackCode">
          <mat-header-cell *matHeaderCellDef mat-sort-header> {{'Rack Code' | translate}} </mat-header-cell>
          <mat-cell *matCellDef="let element" (dblclick)="editRow(element)"> {{element.rackCode}} </mat-cell>
        </ng-container>

        <ng-container matColumnDef="drivingDirection">
          <mat-header-cell *matHeaderCellDef mat-sort-header>  {{'Driving Direction' | translate}} </mat-header-cell>
          <mat-cell *matCellDef="let element" (dblclick)="editRow(element)"> {{element.drivingDirection}} </mat-cell>
        </ng-container>

        <ng-container matColumnDef="x">
          <mat-header-cell *matHeaderCellDef mat-sort-header>  {{'Coordinate X' | translate}}</mat-header-cell>
          <mat-cell *matCellDef="let element" (dblclick)="editRow(element)"> {{element.x}} </mat-cell>
        </ng-container>

        <ng-container matColumnDef="y">
          <mat-header-cell *matHeaderCellDef mat-sort-header>  {{'Coordinate Y' | translate}} <br>
          </mat-header-cell>
          <mat-cell *matCellDef="let element" (dblclick)="editRow(element)"> {{element.y}} </mat-cell>
        </ng-container>

        <ng-container matColumnDef="depth">
          <mat-header-cell *matHeaderCellDef mat-sort-header>  {{'Size Depth(X)' | translate}} </mat-header-cell>
          <mat-cell *matCellDef="let element" (dblclick)="editRow(element)"> {{element.depth}} </mat-cell>
        </ng-container>

        <ng-container matColumnDef="width">
          <mat-header-cell *matHeaderCellDef mat-sort-header>  {{'Size Width(Y)' | translate}} </mat-header-cell>
          <mat-cell *matCellDef="let element" (dblclick)="editRow(element)"> {{element.width}} </mat-cell>
        </ng-container>

        <ng-container matColumnDef="height">
          <mat-header-cell *matHeaderCellDef mat-sort-header>  {{'Size Height(Z)' | translate}} </mat-header-cell>
          <mat-cell *matCellDef="let element" (dblclick)="editRow(element)"> {{element.height}} </mat-cell>
        </ng-container>

        <ng-container matColumnDef="building">
          <mat-header-cell *matHeaderCellDef mat-sort-header>  {{'Building Number' | translate}} </mat-header-cell>
          <mat-cell *matCellDef="let element" (dblclick)="editRow(element)"> {{element.building}} </mat-cell>
        </ng-container>

        <ng-container matColumnDef="shelfCount">
          <mat-header-cell *matHeaderCellDef mat-sort-header>  {{'Shelf Count' | translate}} </mat-header-cell>
          <mat-cell *matCellDef="let element" (dblclick)="editRow(element)"> {{element.shelfCount}} </mat-cell>
        </ng-container>

        <ng-container matColumnDef="columnCount">
          <mat-header-cell *matHeaderCellDef mat-sort-header> {{'Column Count' | translate}}  </mat-header-cell>
          <mat-cell *matCellDef="let element" (dblclick)="editRow(element)"> {{element.columnCount}} </mat-cell>
        </ng-container>

        <ng-container matColumnDef="history">
          <mat-header-cell *matHeaderCellDef> {{'History' | translate}}  </mat-header-cell>
          <mat-cell *matCellDef="let element">
              <mat-icon (click)="showHistory(element)" class="history">history</mat-icon>
          </mat-cell>
        </ng-container>
        
        <ng-container matColumnDef="delete">
            <mat-header-cell *matHeaderCellDef>{{'Delete' | translate}}</mat-header-cell>
            <mat-cell *matCellDef="let element">
              <mat-icon (click)="deleteRackData(element.rackCode)"  class="delete">delete</mat-icon>
            </mat-cell>
          </ng-container>

        <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
        <mat-row *matRowDef="let row; columns: displayedColumns;" (click)="selection.toggle(row)"></mat-row>
      </mat-table>
      <div class="noRecord" *ngIf="length === 0">
        <span>{{'No Records Found' | translate}} </span>
      </div>
      <mat-paginator *ngIf="length !== 0" #paginator [length]="length" [pageSizeOptions]="pageSizeOptions"
        [pageSize]="pageSize" [showFirstLastButtons]="true" (page)="handleRackPage($event, length)">
      </mat-paginator>
    </div>
    <!-- <div class="example-container mat-elevation-z8" >
      Loading...
      <ngx-spinner bdColor="rgba(51,51,51,0.8)" size="medium" color="#fff" loadingText="Loading..." type="ball-scale-multiple">
      </ngx-spinner>
    </div> -->
  </div>

</div>
